module.exports = __webpack_public_path__ + "static/images/final.b3860cd.png";